import React, { useEffect, useState } from 'react';
import io, { Socket } from 'socket.io-client';
import { GameLobby } from './Lobby';
import { Cardate, roomDataType } from './Cardate';
import { initAudioContext } from './SoundEffect';
import ImagePreload from './ImagePreload';

const SERVER_URL = "https://bad-assort.com";
const defaultSocket = io(SERVER_URL, {
  path: "/api-yaminoge/socket.io/",
  transports: ["websocket", "polling"],
  withCredentials: true
});

export default function App() {
  const [socket] = useState<Socket | null>(defaultSocket);
  const [roomData, setRoomData] = useState<roomDataType | null>(null);
  const [errorState, setErrorState] = useState<string | null>(null);
  const [playerName, setPlayerName] = useState<string>('');
  const [icon, setIcon] = useState<string>("sample");
  const [imagesLoaded, setImagesLoaded] = useState<boolean>(false);
  const [imgList, setImgList] = useState<string[]>([]);

  const to = "https://bad-assort.com/play/yaminoge/fileList.php";
  const fetchImgList = async () => {
    const response = await fetch(to);
    const data = await response.json();
    const imageArray: string[] = Object.values(data);
    setImgList(imageArray);
  };

  useEffect(() => {
    fetchImgList();
  }, []);

  initAudioContext();
  socket?.on("connect", () => {
    setErrorState("接続を確立しました");
  });

  socket?.on("connect_error", (error) => {
    if (socket.active) {
      // temporary failure, the socket will automatically try to reconnect
    } else {
      setErrorState("接続が切断されました\nリロードしてください");
      console.log(error.message);
    }
    setRoomData(null);
  });

  socket?.on("user_error", (data) => {
    console.log("receive user_error");
    setErrorState(data.text);
  });

  socket?.on("disconnect", (reason, details) => {
    setRoomData(null);
    setErrorState("接続が切断されました");
  });

  socket?.on("game_update", (data) => {
    console.log("receive game_update");
    setRoomData(data);
  });

  return <>
    {roomData !== null && socket ? <Cardate socket={socket} setErrorState={setErrorState} roomData={roomData} setRoomData={setRoomData}></Cardate> : <GameLobby socket={socket} setErrorState={setErrorState} playerName={playerName} setPlayerName={setPlayerName} icon={icon} setIcon={setIcon}></GameLobby>}
    {errorState && (<div id='error-popup' key={errorState}>{errorState}</div>)}
    {!imagesLoaded && imgList.length > 0 && <div className='absolute inset-0 bg-slate-700/50 z-[1000] flex justify-center items-center'><ImagePreload imgDir={null} imgList={imgList} setImagesLoaded={setImagesLoaded}></ImagePreload></div>}
  </>;
}
